import { render, staticRenderFns } from "./SalesChannelGroup.vue?vue&type=template&id=56de9bad"
import script from "./SalesChannelGroup.vue?vue&type=script&lang=js"
export * from "./SalesChannelGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports